const trimProtocolFromUrl = (url: string) => url.replace(/https?:\/\//, "")

export default trimProtocolFromUrl
